import React from "react";

const Bash_Chgrp = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Chgrp</h2>
      <p>Change the group ownership of a file.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>chgrp [group] file</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>chgrp staff file.txt
chgrp -R devs /project</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Useful when managing shared directories.</p>
    </div>
  );
};

export default Bash_Chgrp;
